// The browser's copy of src/lib/placeholders.ts: [bracketed] gaps the AI left for the owner, never
// the text of a Markdown link "[text](url)". test/placeholders.test.ts keeps the two in step.

const PLACEHOLDER = /\[[^[\]\n]+\](?!\()/;

export function hasPlaceholder(...texts) {
  return texts.some((t) => PLACEHOLDER.test(t ?? ""));
}
